import axiosInstance from '../../core/axiosConfig';
import { adminEventHandlers } from '../../hooks/useAdminEvents';
import { formatMoney } from '../coupons/couponTypes';
import { Discount } from './discountTypes';

/* Zdarzenie z backendu niesie tylko id rabatu - nazwe i budzet dociagamy przez REST,
   ktory sprawdza dostep do lokalu (SPEC-admin-notifications). */
adminEventHandlers.DISCOUNT_BUDGET_EXHAUSTED = async (event) => {
  const { data: discount } = await axiosInstance.get<Discount>(`discount/${event.entityId}`);

  return {
    id: `DISCOUNT_BUDGET_EXHAUSTED-${event.entityId}`,
    messageKey: 'adminEvents.discountBudgetExhausted',
    params: {
      name: discount.name,
      budget: discount.budget != null ? formatMoney(discount.budget) : '—',
    },
    link: `/discounts/${event.entityId}`,
  };
};
